module.exports = __webpack_public_path__ + "img/collage_bolsa.46629203.png";